import { useLocation } from 'react-router-dom';
import { withReturnTo } from '../useReturnTo';

// Sign-in link that brings people back to the page they started on
export const useSignInPath = () => {
  const { pathname, search } = useLocation();
  const isSignInFlow = pathname.startsWith('/sign-in') || pathname === '/welcome';
  return withReturnTo('/sign-in', isSignInFlow ? '/' : `${pathname}${search}`);
};
